import Vue from 'vue';

Vue.filter('truncate', (value, length = 130) => {
  let truncated;
  try {
    truncated = value.length > length ? `${value.substring(0, length)}...` : value;
  } catch {
    truncated = 'Описание отсутствует';
  }
  return truncated;
});
